import { navigateTo } from '../http/redirect';

function closeEnquiryConfirmation() {
    if ( window.router.initialState.isRoutedPopup ) {
        navigateTo( document.body.dataset.baseUrl || '/' );
        return;
    }
    window.router.Rewind();
}

/**
 * @description onPropertyEnquiryClose handles the event triggered for closing the property enquiry confirmation
 * @param {MouseEvent} event - the native MouseEvent event triggered
 */
function onPropertyEnquiryClose() {
    closeEnquiryConfirmation();
}

/**
 * @description onPropertyEnquiryCloseWithYes handles the event triggered for closing the property enquiry confirmation
 * when the user chose "Yes" to also send an enquiry to similar agents/properties
 * @param {MouseEvent} event - the native MouseEvent event triggered
 */
function onPropertyEnquiryCloseWithYes( event ) {
    var target = event.target;

    target.setAttribute( 'disabled', 'disabled' );
    target.classList.add( 'btn--loading' );

    http( target.dataset.url, {
        method: 'POST',
        body: target.dataset.enquiry,
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
        },
    } )
        .then( function( response ) {
            return response.json();
        } )
        .then( function( result ) {
            if ( result.success && result.data ) {
                twc.track( 'property-similar-email', { props: result.data } );
                closeEnquiryConfirmation();
            }
        } )
        .catch( function() {
            target.classList.remove( 'btn--loading' );
        } );
}

/**
 * @description onPropertyEnquiryCloseWithNo handles the event triggered for closing the property enquiry confirmation
 * when the user chose "No" to not send an enquiry to similar agents/properties
 * @param {MouseEvent} event - the native MouseEvent event triggered
 */
function onPropertyEnquiryCloseWithNo( event ) {
    closeEnquiryConfirmation();
}

export {
    onPropertyEnquiryClose,
    onPropertyEnquiryCloseWithNo,
    onPropertyEnquiryCloseWithYes,
};
